import getCommonMethod from './getCommonMethod';

const nativeMethodCalling = getCommonMethod(); // common variable which will be use for native method calling

export default nativeMethodCalling;
